/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Typography from "@insite/mobius/Typography";
import React from "react";
import { css } from "styled-components";

interface Props {
    total: number | undefined;
    singularLabel: string;
    pluralLabel: string;
    displayZeroResult?: boolean;
}

const Pluralize = ({ total, singularLabel, pluralLabel, displayZeroResult }: Props) => {
    let label = singularLabel;
    if (total === undefined || (total === 0 && !displayZeroResult)) {
        return null;
    }
    if (total > 1) {
        label = pluralLabel;
    }
    return (
        <>
            <Typography
                css={css`
                    margin-right: 5px;
                `}
                as="span"
            >{`${total}`}</Typography>
            <Typography as="span" className="total-label">{`${label}`}</Typography>
        </>
    );
};

export default Pluralize;
